<template>
  <a href="/en-vivo" class="live show d-flex flex-row" v-if="live">
    <div class="icon-live">
      <img
        src="https://s.lalr.co/lr/images/icon-live-gif.gif"
        alt="Inside"
      /><span>EN VIVO</span>
    </div>
    <div class="flex-grow-1 content align-items-center">
      <div class="line"></div>
      <img
        alt="Logo Inside"
        v-if="live.isInside"
        class="img-inside"
        src="https://s.lalr.co/lr/images/logos/logo-Inside.png"
      />
      <!-- <span
        class="type"
        v-if="!live.isInside"
        v-html="live.principalTitle"
      ></span> -->
      <span class="tittle" v-html="live.title"></span>
    </div>
    <div class="btn">VER AHORA</div>
  </a>
</template>

<script>
import axios from "axios";
export default {
  created: function () {
    this.$refreshHub.$on("live-refreshed", this.search);
    this.search();
  },
  methods: {
    search: function () {
      const _self = this;
      axios.get("/api/live").then(function (d) {
        _self.live = d.data.live;
      });
    },
  },
  data: function () {
    return {
      live: null,
    };
  },
};
</script>